import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import cn from 'classnames';
import styles from './blog-card.module.css';
import { BlogCardListProps, BlogCardProps } from './blog.types';

function BlogCard({ article }: BlogCardProps) {
  return (
    <div className={cn(styles.blogCard)}>
      <Link href={`/blog/${article.slug}`} prefetch={false}>
        <div className={styles.blogCard_image}>
          <Image
            alt={article.title}
            width={436}
            height={260}
            className={styles.blogCard_img}
            objectFit="cover"
            src={article.cover}
          />
        </div>
      </Link>
      <div className={styles.blogCard_footer}>
        <time className={styles.blogCard_time}>{article.date}</time>
        <Link href={`/blog/${article.slug}`} prefetch={false}>
          <a>
            <h3 className={styles.blogCard_title}>{article.title}</h3>
          </a>
        </Link>
        <p className={styles.blogCard_text}>{article.subtitles[0]?.text}</p>
        <span className={styles.blogCard_hashtag}>
          {article?.theme?.map((t) => t.name)}
        </span>
      </div>
    </div>
  );
}

export default function BlogCardList({
  className,
  articles,
}: BlogCardListProps) {
  return (
    <ul className={cn(styles.blogCardList, className)}>
      {articles.map((article) => (
        <li key={article.id} className={styles.blogCardList_item}>
          <BlogCard article={article} />
        </li>
      ))}
    </ul>
  );
}
